<template>
  <transition class="toast" name="toast-fade">
    <div role="alert" aria-live="polite"
      v-show="isActive"
      class="toast"
      @click="clicked">
      <div class="toast_bar"
        :class="'toast_type__' + type">{{title }}
        <div class="toast_body">{{ message }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'toast',
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info'
    },
    duration: {
      type: Number,
      default: 3000
    },
    title: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    return {
      isActive: false,
      parent: null,
    }
  },
  beforeMount() {
    this.setup()
  },
  mounted() {
    this.show();
  },
  methods: {
    setup() {
      this.parent = document.querySelector('.toast');
      if (this.parent) return;
      if (!this.parent) {
        this.parent = document.createElement('div');
        this.parent.className = 'toast toast--top';
      }
      const container = document.body;
      container.appendChild(this.parent);
    },
    async dismiss(duration) {
      const sleep = (callback, duration) => {
        return new Promise((resolve) => {
          return setTimeout(() => {
            callback();
            return resolve();
          }, duration);
        });
      };
      await sleep(() => { this.isActive = false; }, duration);
      await sleep(() => {
        this.$destroy();
        this.remove(this.$el);
      }, 500);
    },
    show() {
      this.correctParent.insertAdjacentElement('afterbegin', this.$el);
      this.isActive = true;
      if (this.duration) {
        this.dismiss(this.duration);
      }
    },
    clicked() {
      this.onClick.apply(null, arguments);
      this.dismiss(0);
    },
    remove(el) {
      if (typeof el.remove !== 'undefined') {
        el.remove()
      } else {
        el.parentNode.removeChild(el)
      }
    },
  },
  computed: {
    correctParent() {
      return this.parent;
    },
  },
}

import Toast from '@/components/parts/common/Toast.vue';
export const toastApi = (Vue) => {
  return {
    open(options) {
      let message;
      if (typeof options === 'string') message = options;
      const defOptions = {
        message
      };
      const unitedOptions = Object.assign({}, defOptions, options);
      return new (Vue.extend(Toast))({
        el: document.createElement('div'),
        propsData: unitedOptions,
      })
    },
    info(message, options = {}) {
      return this.open(Object.assign({}, {
        message,
        type: 'info'
      }, options))
    },
    cancel(message, options = {}) {
      return this.open(Object.assign({}, {
        message,
        type: 'cancel'
      }, options))
    },
    error(message, options = {}) {
      return this.open(Object.assign({}, {
        message,
        type: 'error',
      }, options))
    },
    auth(message, options = {}) {
      return this.open(Object.assign({}, {
        message,
        type: 'auth',
      }, options))
    },
    memo(message, options = {}) {
      return this.open(Object.assign({}, {
        message,
        type: 'memo', duration: 5000,
      }, options))
    },
  }
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 100px;
  width: 325px;
  right: 20px;
  z-index: 20000;
}

.toast_bar {
  background-color: #fff;
  font-size: 1.4rem;
  padding: 20px;
  border-radius: 4px;
  position: relative;
  -webkit-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.5);
          box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.5);
  line-height: 1.4;
  margin-bottom: 10px;
}

.toast_bar:hover {
  opacity: .9;
}

.toast_bar.toast_type__info {
  background-color: rgba(0, 112, 190, 0.9);
  color: #fff;
}

.toast_bar.toast_type__cancel {
  background-color: rgba(22, 166, 177, 0.9);
  color: #fff;
}

.toast_bar.toast_type__error {
  background-color: rgba(255, 0, 0, 0.9);
  color: #fff;
}

.toast_bar.toast_type__auth {
  background-color: rgba(245,198,203,.85);
  color: #721c24;
  font-weight: bold;
}
.toast_bar.toast_type__memo {
  background-color: rgba(255, 249, 231, 0.974);
  color: #ff6776;
  font-weight: bold;
  border-radius: 8px;
  border-style: solid;
  border-color: #ff6776;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all .5s ease;
}

.toast-fade-enter{
  transform: translateX(1000px);
  opacity: .5;
}

.toast-fade-leave-to {
  transform: translateX(1000px);
  opacity: .5;
}
</style>
